import coreStore from "./core-store";

const remoteResource = 'cashflow/api/v1/queries';

const store = coreStore.searchQueryStore(coreStore.createCoreStore('cashEffectQuery', remoteResource, 'cashEffectQueries'))

export default store;
